const About = () => {


  const values = [
    {
      title: 'Transparency',
      description: 'Clear pricing, no hidden fees, and open communication with our community.',
      icon: '🔍'
    },
    {
      title: 'Innovation',
      description: 'Continuously improving our technology to give traders the competitive edge.',
      icon: '💡'
    },
    {
      title: 'Security',
      description: 'Bank-grade security measures to protect your assets and data.',
      icon: '🔒'
    },
    {
      title: 'Accessibility',
      description: 'Making institutional-grade tools available to traders of all levels.',
      icon: '🌐'
    }
  ]

  return (
    <div className="min-h-screen bg-neutral dark:bg-secondary">
      {/* Header */}
      <section className="bg-gradient-primary text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            About Unitradeinternational
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl">
            Building the future of global trading with institutional-grade technology accessible to everyone.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="section-container bg-secondary-light dark:bg-secondary">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white mb-6">
            Our Mission
          </h2>
          <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed mb-8">
            We're on a mission to level the playing field in financial markets. By combining institutional-grade infrastructure with retail accessibility, we empower traders worldwide to compete with the same tools and data used by Wall Street professionals.
          </p>
          <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
            Since 2019, we've built a platform that processes over $125 billion in daily trading volume, serving everyone from individual day traders to multinational hedge funds. Our commitment to transparency, security, and innovation drives everything we do.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="section-container bg-neutral dark:bg-secondary">
        <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white mb-12 text-center">
          Our Core Values
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl mb-4">{value.icon}</div>
              <h3 className="text-xl font-bold text-secondary dark:text-white mb-3">
                {value.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default About
